<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#A7BA38" title="">
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <v-btn
          class="mx-2"
          fab
          dark
          small
          color="success"
          @click="$router.push({ name: 'Home' })"
        >
          <v-icon dark>
            mdi-keyboard-backspace
          </v-icon>
        </v-btn>
        <br/>
        <br/>
        <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12" v-if="active == 0">
          <v-alert
            prominent
            type="info"
          >
           Servicio temporalmente inactivo
          </v-alert>
        </v-col>
        <div v-else>
          <v-row v-if="userProfile">
            <v-col md="12">
            <template>
                <v-card
                  class="mx-auto"
                  max-heighh="294"
                >
                  <v-img
                    class="mx-auto"
                    :height="$vuetify.breakpoint.name == 'xs' ? 'auto' : 280"
                    :src="userProfile.cover_photo !==null ? userProfile.cover_photo : 'https://www.geeklawblog.com/wp-content/uploads/sites/528/2018/12/liprofile-656x369.png'"
                  >
                    <v-row
                      class="fill-height"
                    >
                      <v-col
                        align-self="start"
                        class="pa-8"
                        
                        xs="12" sm="4" md="2" xl="2" lg="2"
                      >
                      <v-hover v-slot="{ hover }" class="mx-auto">
                        
                        <v-avatar
                          class="profile justify-center"
                          color="info"
                          v-if="hover && editProfile"
                          @click="uploadPhotoProfile()"
                          :size="$vuetify.breakpoint.name == 'xs' ? 250 : 165"
                          style="display: block;"
                        >
                          <v-icon  class="white--text  text-center" size="30">mdi-camera</v-icon>
                        </v-avatar>
                      
                        <v-avatar
                          class="profile ustify-center"
                          color="info"
                          :size="$vuetify.breakpoint.name == 'xs' ? 250 : 165"
                          v-else
                          style="display: block;"
                        >
                          <v-img :src="userProfile.image" v-if="userProfile.image" ></v-img>
                         
                          <v-icon  v-else size="100">mdi-account</v-icon>
                        </v-avatar>
                      </v-hover>
                      </v-col>
                      <v-col
                      
                      class="pa-5"
                      xs="12" sm="7" :md="editProfile ? 8 : 9" :xl="editProfile ? 8 : 9" :lg="editProfile ? 8 : 9"
                      >
                        <v-list-item
                          color="rgba(0, 0, 0, .4)"
                          dark
                          cols="9"
                          class="justify-center"
                        >
                          <v-list-item-content>
                            <v-list-item-title class="text-h6">
                              {{userProfile.responsable}}
                             
                             <div v-if="userProfile.tipo_usuario == 'empresa'">
                               
                               <v-btn
 
                                 class="mx-2"
                                 dark
                                 small
                                 color="info"
                                 @click="editProfile=true;content=userProfile.descripcion;estadoCivil=userProfile.estadoCivil"
                                 v-if="!editProfile"
                               >
                               <v-icon
                                   dark
                                   small
                                 >
                                   mdi-pencil
                                 </v-icon>
                                  Editar
                               </v-btn>
                               <v-btn
 
                                 class="mx-2"
                                 dark
                                 small
                                 color="success"
                                 @click="updateProfile()"
                                 v-else
                               >
                                 <v-icon
                                   dark
                                   small
                                 >
                                   mdi-content-save
                                 </v-icon>
                                  Guardar
                               </v-btn>
                             </div>
                              <div>
                                <v-rating
                                  :value="userProfile.puntaje || 5"
                                  color="amber"
                                  dense
                                  half-increments
                                  readonly
                                  size="14"
                                ></v-rating>
                              </div>
                            </v-list-item-title>
                           
                             
                              <br/>
                              <v-list-item-subtitle v-if="editProfile" class="pt-2">
                                <v-textarea
                                  outlined
                                  v-model="content"
                                  name="input-7-4"
                                  label="¿Qué estas pensando?"
                                  rows="2"
                                ></v-textarea>
                              </v-list-item-subtitle>
                            <v-list-item-subtitle v-else>
                              <span>{{userProfile.descripcion}}</span>
                             
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col
                        xs="1" sm="1" md="2" xl="2" lg="2" class="d-flex flex-row-reverse"
                      >
                        <v-btn
                        class="mx-2 float-right"
                        dark
                        small
                        color="error"
                        @click="uploadPhotoCover()"
                        v-if="editProfile"
                        title="Cambiar imagen de portada"
                      >
                        <v-icon
                          dark
                          small
                        >
                          mdi-image
                        </v-icon>
                      </v-btn>
                      </v-col>
                    </v-row>
                  </v-img>
                </v-card>
              </template>
            </v-col>
          </v-row>
          <br/>
          <!-- <div class="text-center">
            <v-progress-circular
                indeterminate
                v-if="loading"
                color="primary"
            ></v-progress-circular>
          </div> -->
          <br/>
          <v-divider></v-divider>
          <br/>
          <div v-if="userProfile">
          <v-row  v-if="publications.length == 0 && waiting == false">
              <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
                <v-alert
                  prominent
                  type="info"
                >
                  {{userProfile.Nombres}} no ha publicado aun nada
                </v-alert>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-container>
                <masonry :gutter="{ default: '30px', 700: '15px' }" :cols="{ default: 2, 1000: 2, 700: 1, 500: 1 }">
                  <v-card v-for="item in publicationsFiltered" :key="item.id" class="mt-2 mb-2" elevation="1" flat>
                    <v-list-item v-if="item.empresa != null" two-line>
                      <v-list-item-icon>
                        <v-avatar size="50" color="#8fc6dc" style="cursor: pointer;"  >
                          <v-img :src="item.empresa.image"></v-img>
                        </v-avatar>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="text-h6">
                           {{item.empresa.razon_social}} <br> 
                           {{item.empresa.responsable}}
                        </v-list-item-title>
                          <v-list-item-subtitle>
                            <v-rating
                              :value="5"
                              color="amber"
                              dense
                              half-increments
                              readonly
                              size="14"
                            ></v-rating>
                          </v-list-item-subtitle>
                          <v-list-item-subtitle><small>Hace {{gettime(item.updated_at)}}</small></v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>

             
                   
                    <v-carousel 
                      hide-delimiters
                      :show-arrows="(item.images.length >= 2) || (item.images.length  == 1 && item.video) ? true: false"
                      v-if="item.images.length >= 2 || item.video"
                      height="300"  
                      >
                      <v-carousel-item
                        v-for="(image,j) in item.images.filter(d => {return (d.active == 1)})"
                        :key="j"
                        :src="image.image"
                        @click="openPublication(item)"
                      ></v-carousel-item>
                      <v-carousel-item
                        v-if="item.video"
                      >
                        <iframe v-if="item.video" width="100%" height="300" :src="item.video" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen class="mt-10"></iframe>
                      </v-carousel-item>
                    </v-carousel>
                    <v-img  @click="openPublication(item)" v-if="item.images.length == 1" :src="item.images[0].image" ></v-img>
                    <v-card-text style="color: #424242" v-html="item.contentHtml.substring(0,150)">
                    </v-card-text>
                    
                    <v-card-actions style="padding-left: 20px;" >
                      
                      <v-spacer></v-spacer>
                      
                     
                    </v-card-actions>
                  </v-card>
                </masonry>
              </v-container>
              <v-row>
              <p class="m-10 p-5 preview d-flex align-center justify-center pa-4 mx-auto" v-if="current_page == last_page">No hay mas publicaciones para mostrar</p>
            </v-row>
            </v-row>
          </div>
        </div>
      </v-col>

      <ModalCustom  :show="show" @update="onUpdateShow" :content="contentAlert" :type="typeAlert"/>
      <ModalCustom  :show="showImageProfile" @update="onUpdateShowImageProfile" :image="userProfile.imagen" :type="typeAlert" :title="userProfile.Nombres +' ' + userProfile.Apellidos" :maxWidth="500" v-if="userProfile" />
      <Publication  :showDialog="showPublication" @updatepublication="onUpdateShowPublication" :publication="publicationSelected" />
      
    
            <!-- </v-row> -->
    </CardIeaAppMain>
  </div>
</template>

<script>
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";
import ModalCustom from "../../components/ModalCustom";
import Publication from "../../components/Publication";
import moment from "moment";
moment.locale('es')
export default {
  name: "Profile",
  components: {
    // CardIeaApp,
    CardIeaAppMain,
    ModalCustom,
    Publication,
  },

  data: () => ({
    title:"Perfil",
    content:"",
    Nacimiento:"",
    estadoCivil:"",
    estadosCiviles:['Soltero', 'Casado', 'Viudo', 'En algo'],
    selection: 1,
    show:false,
    contentAlert:"",
    typeAlert:"modal-info",
    showPublication:false,
    publications: [],
    imageSelected:'',
    publicationSelected:null,
    // loading:false,
    url:null,
    files:[],
    limit:10,
    video:null,
    current_page:0,
    last_page:1,
    action:'add',
    publication:null,
    current_index:null,
    images_deleted:[],
    active:1,
    userProfile:null,
    showFollowers:false,
    showFollowings:false,
    followers:[],
    followings:[],
    editProfile:false,
    filePhoto:null,
    filePhotoCover:null,
    showImageProfile:false,
    tipo_usuario: null,
    waiting: true
  }),
  mounted() {
    this.current_page = 0;
    this.verifierStatus();
    let id = this.$route.params.id;
    let tipo_usuario = this.$route.params.tipo_usuario;
    this.tipo_usuario = tipo_usuario;
    if(id){
      this.getProfile(id,tipo_usuario);
    }else{
      console.log(this.user);
      this.getProfile(this.user.IDStB,this.user.tipoUsuario);
    }    
    window.addEventListener("scroll", this.onScroll)
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll)
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    publicationsFiltered() {
      const result = [];
      for (const p of this.publications) {
        p.contentHtml = p.content;
        if(p.taggeds && p.taggeds.length > 0){
          p.taggeds.forEach((val)=>{
            console.log(val);
            let t = new Date().getTime();
            p.contentHtml = p.content.replace(val.shortName, '<a class="tagged" href="profile/'+val.IDStB+"/"+val.tipoUsuario+'?t='+t+'">'+val.shortName+'</a>');
          }); 
        }
        result.push(p)
      }
      console.log(result)
      return result;
    },
  },
  methods: {
    async verifierStatus(){
      this.$API
      .get({
        url: "publications-service-status"
      }).then((res) => {
        this.active = res
      });
    },
    async getAlumnoLogged(){
      this.$API
      .get({
        url: "alumno/getAlumno"
      }).then((res) => {
        console.log(res)
        this.followers = res.followers;
        this.followings = res.followings;
      });
    },
    gettime(date_publish){
      let current_date = moment();
      let published_date = moment(date_publish);
      return (moment.duration(current_date - published_date).humanize())
    },
    async getProfile(id,tipo_usuario) {
      // this.loading = true;
      this.$API
        .get({
          url: "profile/"+id+"/"+tipo_usuario
        }).then((res) => {
          console.log(res)
          this.userProfile = res;
          // this.loading = false;
          this.getPublications(true);
        });
    },

    async getPublications(reload = false) {
      console.log(this.userProfile)
      if(this.userProfile && this.current_page !== this.last_page && this.current_page < this.last_page ){
        // this.loading = true;
        this.$API
          .get({
            url: "work-bag-by-bussines?empresa_id="+this.userProfile.id+"&page="+this.current_page
          }).then((res) => {
            console.log(res)
            if(reload){
              this.publications = res.data;
              this.waiting = false;
            }else{
              this.publications.push(...res.data);
              this.waiting = false;
            }
            this.last_page = res.last_page;
            this.current_page++;
            // this.loading = false;
          });
      }
    },
    async getPublication(id) {
      this.$API
        .get({
          url: "publications/"+id
        }).then((res) => {
          this.openPublication(res);
        });
    },
    async test() {
      this.$API
        .get({
          url: "notifications?type=message"
        }).then((res) => {
          console.log(res)
        });
    },
    async follow() {
      await this.$API
        .post({
          url: "follow/"+this.userProfile.IDStB,
          data: {}
        }).then(res => {
            this.userProfile.followers.push(res)
        });
    },
    async unfollow() {
      await this.$API
        .post({
          url: "unfollow/"+this.userProfile.IDStB,
          data: {}
        }).then(res => {
            let t = this.userProfile.followers.findIndex(d => {return (d.follower_id == this.user.IDStB)});
            if(t !== -1){
              this.userProfile.followers.splice(t, 1);
            }
            console.log(res)
        });
    },
    async uploadVideoEvent() {
      this.$refs.fileInputVideo.click()   
    },
    openPublication(item){
      this.showPublication = true;
      this.publicationSelected = item;
    },
    onUpdateShow (newData) {
      this.show = newData
    },
    onUpdateShowPublication (newData) {
      this.showPublication = newData
    },
    onUpdateShowImageProfile (newData) {
      this.showImageProfile = newData
    },
    async addLike(item) {
      console.log("data del alumno o del usuario:",item);
     await this.$API
      .post({
        url: "publications-like",
        data: {
          publication_id:item.id,
        }
      }).then(res => {
         
          if (res.alumno != null){
          item.likes.push(res);
          }else{
            item.likes_profesor.push(res);
          }
      });
    },
   async updateProfile() {
    var formData = new FormData();
    formData.append('descripcion',this.content);
    formData.append('estadoCivil',this.estadoCivil);
    if(this.filePhoto){
      formData.append('imagen', this.filePhoto);
    }
    if(this.filePhotoCover){
      formData.append('cover_photo', this.filePhotoCover);
    }
     await this.$API
      .post({
        url: "profile",
        data: formData
      }).then(res => {
          if (this.user.tipoUsuario == 'empresa') {
            this.editProfile=false;
          this.userProfile.descripcion = res.descripcion;
          this.userProfile.estadoCivil = res.estadoCivil;
          this.userProfile.imagen = res.imagen;
          } else {
          this.editProfile=false;
          this.userProfile.empleado.descripcion = res.empleado.descripcion;
          //this.userProfile.estadoCivil = res.estadoCivil;
          this.userProfile.empleado.imagen = res.empleado.imagen;
          }
      });
    },
    async removeLike(item) {
     await this.$API
      .delete({
        url: "publications-like-bypost/" + item.id
      }).then(res => {
        if(res){
          item.likes = item.likes.filter(d => {return (d.alumno.IDStB != this.user.IDStB)})
          item.likes_profesor = item.likes_profesor.filter(d => {return (d.profesor.IDStB != this.user.IDStB)})
        }
      });
    },
    deleteFileThumnail(index, id){
      this.files.splice(index, 1);
      if(id){
        this.images_deleted.push(id)
        console.log(this.images_deleted)
      }
    },
    onScroll(){
      if (document.body.scrollHeight - window.innerHeight - window.top.scrollY === 0) {
        this.getPublications();
      }
    },
    openProfile(id,tipo_usuario){
      console.log(id,tipo_usuario);
      this.$router.push({
        name: 'Profile',
        params: {
          id: id,
          tipo_usuario : tipo_usuario,
        },
        query: {
          t: new Date().getTime(),
        }
      });  
    },
   
    async uploadPhotoProfile() {
      this.$refs.fileInputProfile.click()   
    },
    onFileChangeProfile(e) {
      let i = e.target.files[0];
      if( i.type.match('image.*')){
        this.filePhoto = i;  
        this.userProfile.imagen = URL.createObjectURL(i);  
      }else{
        this.typeAlert = 'info';
        this.contentAlert = 'Agrega un formato válido de fotografia';
        this.show=true;
      }
    },
    async uploadPhotoCover() {
      this.$refs.fileInputCover.click()   
    },
    onFileChangeCover(e) {
      let i = e.target.files[0];
      if( i.type.match('image.*')){
        this.filePhotoCover = i;  
        this.userProfile.cover_photo = URL.createObjectURL(i);  
      }else{
        this.typeAlert = 'info';
        this.contentAlert = 'Agrega un formato válido de fotografia';
        this.show=true;
      }
    },
    openImageProfile(){
      this.showImageProfile = true
    },
    getColor(){
      let colors = ['#a7ba38', '#095da1', '#e79029', '#dd404a', '#8fc6dc'];
      let min=0;
      var max=colors.length; 
      var random = Math.floor(Math.random() * (max - min)) + min;
      return colors[random];
    }
  }
};
</script>
    <style>
  .v-card__subtitle, .v-card__text {
      font-size: 0.875rem;
      font-weight: 400;
      line-height: .95rem !important;
      letter-spacing: 0.007143em;
  }
  .preview{
    margin:10px;
  }
  .preview img {
    margin: 5px;
    max-width: 90%;
  }
  .v-chip.v-size--default{
    height: auto !important;
    
  }
  .v-chip .v-icon{
    font-size: 14px;
  }
  </style>